import { render, staticRenderFns } from "./PaoListTabLinkedPao.vue?vue&type=template&id=4a958caa&scoped=true"
import script from "./PaoListTabLinkedPao.vue?vue&type=script&lang=js"
export * from "./PaoListTabLinkedPao.vue?vue&type=script&lang=js"
import style0 from "./PaoListTabLinkedPao.vue?vue&type=style&index=0&id=4a958caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a958caa",
  null
  
)

export default component.exports